import { START_OPERATION, CONTINUE_OPERATION, BACK, CANCEL_CARD_OPERATION } from '../store/cardOperationActions';
import { logCustomerCardPageAction } from './newRelicLogging';
import type { CustomerCardState } from '../types';

export const OPERATION_LIFECYCLE_ACTION_TYPES = [START_OPERATION, CONTINUE_OPERATION, BACK, CANCEL_CARD_OPERATION] as const;

type OperationLifecycleAction = { type: string; payload?: unknown; meta?: { operationId?: string } };

/**
 * Decides whether an operation-lifecycle action (start/continue/back/cancel) should be logged as a
 * CustomerCardOperation PageAction, and if so, does it.
 *
 * `customerCard` must be the slice as it stood *before* the action's reducer ran — BACK and
 * CANCEL_CARD_OPERATION clear or step back the very operation this reads, so a post-reducer read
 * would find it already gone. START_OPERATION/CONTINUE_OPERATION don't touch dealId/dealerId, so
 * the same pre-transition read is correct for them too — callers don't need to branch on timing.
 */
export const logOperationLifecycleEvent = (action: OperationLifecycleAction, customerCard: CustomerCardState | undefined): void => {
    const dealId = customerCard?.dealId;
    const dealerId = customerCard?.dealerId;

    switch (action.type) {
        case START_OPERATION:
            logCustomerCardPageAction('CustomerCardOperation', {
                event: 'start',
                operationKind: action.payload,
                operationId: action.meta?.operationId,
                dealXgId: dealId,
                dealerId
            });
            return;
        case CONTINUE_OPERATION:
            if (customerCard?.operation) {
                logCustomerCardPageAction('CustomerCardOperation', {
                    event: 'continue',
                    operationKind: customerCard.operation.kind,
                    operationId: customerCard.operation.operationId,
                    dealXgId: dealId,
                    dealerId
                });
            }
            return;
        case BACK:
        case CANCEL_CARD_OPERATION:
            if (customerCard?.operation) {
                logCustomerCardPageAction('CustomerCardOperation', {
                    event: action.type === BACK ? 'back' : 'cancel',
                    operationKind: customerCard.operation.kind,
                    operationId: customerCard.operation.operationId,
                    fromStep: customerCard.operation.step,
                    dealXgId: dealId,
                    dealerId
                });
            }
            return;
    }
};
